<template>
  <div>
    <v-tabs v-model="activeTab">
      <v-tab>Detalle de Ventas</v-tab>
      <v-tab>Data</v-tab>
      <v-tab>Raw</v-tab>
      <v-tab-item class="pa-4">
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field
              type="text"
              label="Folio"
              :value="selectedReserva.Folio ? selectedReserva.Folio : ''"
              placeholder="First Name"
              readonly
            />
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              type="text"
              label="Turno"
              :value="selectedReserva.Turno ? selectedReserva.Turno.id : ''"
              placeholder="Turno"
              readonly
            />
          </v-col>
          <v-col md="12" cols="12">
            <v-text-field
              type="text"
              label="Cliente"
              :value="
                selectedReserva.Cliente ? selectedReserva.Cliente.Nombre : ''
              "
              placeholder="First Name"
              readonly
            />
          </v-col>
          <v-col md="4" cols="12">
            <v-text-field
              type="text"
              :value="
                selectedReserva.FechaVenta ? selectedReserva.FechaVenta : ''
              "
              label="Fecha"
              placeholder="fecha"
              readonly
            />
          </v-col>
          <v-col md="4" cols="12">
            <v-text-field
              type="text"
              :value="
                selectedReserva.Caja
                  ? selectedReserva.Caja.nm
                  : ''
              "
              label="Caja"
              placeholder="caja"
              readonly
            />
          </v-col>
          <v-col md="4" cols="12">
            <v-text-field
              type="text"
              :value="
                selectedReserva.Cajero
                  ? selectedReserva.Cajero.nm
                  : ''
              "
              label="Cajero"
              placeholder="cajero"
              readonly
            />
          </v-col>
          <v-col md="12" cols="12">
            <v-text-field
              type="text"
              label="Total"
              :value="
                selectedReserva.Total
                  ? formatNumber(selectedReserva.Total.C) + ' MXN'
                  : 0
              "
              readonly
            />
          </v-col>
          <v-col md="12" cols="12">
            <div>
              <h3>Productos</h3>
            </div>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Productos</th>
                  <th>Cantidad</th>
                  <th>Precio U.</th>
                  <th>Precio Total</th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-for="(producto, index) in selectedReserva.ListProducts
                    ? selectedReserva.ListProducts
                    : []"
                >
                  <tr :key="index">
                    <td data-label="producto">
                      {{ producto[1].Nombre }}
                      <template
                        v-for="(modi, idx) in producto[1].Modificadores"
                      >
                        <li :key="idx">
                          {{ modi.cn }} - {{ modi.nm }} - {{ modi.pu.C }}
                          {{ modi.pu.M }}
                        </li>
                      </template>
                      <template v-for="(Desc, idx) in producto[1].Descuentos">
                        <li :key="idx + 1000">
                          {{ Desc.cn }} - {{ Desc.ds }} {{ Desc.td.C }}
                          {{ Desc.td.M }}
                        </li>
                      </template>
                    </td>
                    <td data-label="Cantidad">{{ producto[1].Cnt }}</td>
                    <td data-label="Precio">
                      {{ producto[1].pu.C }} {{ producto[1].pu.M }}
                    </td>
                    <td data-label="Precio">
                      {{ $pgsHelper.formatNumber(producto[1].td.C) }}
                      {{ producto[1].td.M }}
                    </td>
                  </tr>
                </template>
                <tr>
                  <td>Totales</td>
                  <td></td>
                  <td></td>
                  <td>
                    {{
                      $pgsHelper.formatNumber(selectedReserva.sumatoriaTotal)
                    }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col md="12" cols="12">
            <div>
              <h3>Pagos</h3>
            </div>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Pago</th>
                  <th>Monto</th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-for="(pago, index) in selectedReserva.Pagos
                    ? selectedReserva.Pagos
                    : []"
                >
                  <tr :key="index">
                    <td data-label="Pago">{{ pago.nm }} {{ pago.rl.M }}</td>
                    <td data-label="Precio">
                      {{ formatNumber(pago.rl.C) }} {{ pago.rl.M }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col md="12" cols="12"></v-col>
        </v-row>
        <h3>Cambio</h3>
        <p v-if="selectedReserva.Cambio">
          {{ $pgsHelper.formatNumber(selectedReserva.Cambio.MXN) }}
        </p>
      </v-tab-item>
      <v-tab-item>
        <v-card outlined>
          <v-card-text>
            <v-treeview
              :items="combinedData"
              item-text="attribute"
              item-children="children"
              open-on-click
            >
              <template v-slot:prepend="{ item }">
                <span>
                  <b>{{ item.attribute }}:</b>
                </span>
              </template>
              <template v-slot:label="{ item }">
                <span v-if="!item.children">{{ item.value }}</span>
              </template>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>{{ selectedReserva }}</v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import "../../../assets/css/sideBar.css";
import Cliente from "../../../clases/Cliente.js";
import Modificadores from "../../../clases/Modificadores.js";
import moment from "moment";

export default {
  name: "ReporteVentas",
  components: {},
  props: ["hideMenu", "selectedRes"],
  data() {
    return {
      activeTab: 0,
      aperturas: [],

      input_orden: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      //selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      selectDep: "",
    };
  },
  computed: {
    combinedData() {
      const formatAttributes = (obj, prefix = "") => {
        return Object.entries(obj).map(([key, value]) => {
          const nombreAtributo = prefix ? `${prefix}.${key}` : key;

          if (typeof value === "object" && value !== null) {
            // Si el valor es un objeto, formatea recursivamente sus hijos
            return {
              attribute: nombreAtributo,
              children: formatAttributes(value), // Crea una sublista para objetos anidados
            };
          } else {
            // Si es un valor primitivo, añádelo como un elemento simple
            return { attribute: nombreAtributo, value: value };
          }
        });
      };

      return formatAttributes(this.selectedReserva);
    },

    getPayMethods() {
      const pagos = {};

      this.$store.getters.getPDVPagosTipos.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            pagos[pago.id + "_" + tipo.id] = {
              id: pago.id + "_" + tipo.id,
              Nombre: pago.Nombre + " " + tipo.Nombre,
            };
          });
        } else if (pago.Moneda == "None") {
          pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        }
      });

      return pagos;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },

    selectedReserva() {
      let selected = this.$pgsHelper.cloneObj(this.selectedRes);
      let totalProd = 0;
      selected.Catalogo.forEach((item)=>{
        totalProd += item.td.C;
      })
      selected.sumatoriaTotal = totalProd;

      return selected;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_resumen_data() {
      let total_products = 0;
      let total_golf_round = 0;
      let total_proshop = 0;
      let total = 0;
      this.data_ventas.forEach((venta) => {
        let prod = Object.entries(venta.Catalogo);
        this.$pgsHelper.log(prod);
        prod.forEach((producto) => {
          if (producto[0] == "Golf_Round") {
            total_golf_round++;
          } else {
            total_proshop++;
          }
          total_products++;
        });
        total = total + parseInt(venta.Total);
      });
      return {
        total_productos: total_products,
        total_rounds: total_golf_round,
        total_proshop: total_proshop,
        total: total,
      };
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto() });
      });
      return clientes;
    },
  },
  methods: {
    cleanFilter() {
      (this.input_date = moment()),
        (this.input_date_final = moment()),
        (this.input_folio = "");
      this.selectClient = "";
      this.input_orden = "";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        //let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = this.selectedRes.Catalogo;
        //let pag = Object.entries(this.selectedRes.Pagos);
        //this.selectedRes.ListPagos = this.selectedRes.Pagos;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      if (num) {
        if (num != undefined) {
          return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
      }
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      this.loadingData = true;
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("FechaVenta", ">=", startDate),
        firestore.where("FechaVenta", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(firestore.where("Departamento", "==", this.selectDep));
      }

      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }

      if (this.input_orden != "") {
        filter.push(firestore.where("Orden", "==", this.input_orden));
      }

      if (this.selectClient != "") {
        filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
      }

      const data = await firestore.queryBuilder("PDV_Ventas", filter);

      this.data_ventas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      this.data_ventas.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
      });
      this.data_ventas = this.$_.orderBy(this.data_ventas, "fecha", "desc");
      this.showEstad = true;
      this.loadingData = false;
    },
    /* async getAperturas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;

      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("Tipo", "==", "Apertura"),
      ];

      if (this.selectDep !== "ALL" && this.selectDep !== "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }

      if (this.selectCaja !== "ALL" && this.selectCaja !== "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }

      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);

      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja =
          this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja) || {};
        let cajeroData =
          this.$pgsHelper.getById(this.cajeros, "Id", apt.Cajero) || {};

        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = cajeroData.Nomb || "Desconocido";
        apt.Desc = `Turno Fecha ${fecha.format(
          "DD-MM-YYYY"
        )} Hora: ${fecha.format("HH:mm")} || ${caja.Nomb ||
          "Sin caja"} || ${cajeroData.Nomb || "Sin cajero"} || Turno: ${
          apt.Turno
        }`;
      });
      console.log(aperturas, "aperturas");
      this.aperturas = aperturas;
    }, */
  },
  beforeCreate: function () {},
  beforeMount: function () {
    console.log(this.selectedRes)
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
